"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsx)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: (0, jsx_runtime_1.jsx)("path", {
      d: "M6.08594 10.0195H1.76172L1.73828 8.20312H5.66406C6.3125 8.20312 6.87891 8.09375 7.36328 7.875C7.84766 7.65625 8.22266 7.34375 8.48828 6.9375C8.76172 6.52344 8.89844 6.03125 8.89844 5.46094C8.89844 4.83594 8.77734 4.32812 8.53516 3.9375C8.30078 3.53906 7.9375 3.25 7.44531 3.07031C6.96094 2.88281 6.34375 2.78906 5.59375 2.78906H2.26562V18H0.00390625V0.9375H5.59375C6.46875 0.9375 7.25 1.02734 7.9375 1.20703C8.625 1.37891 9.20703 1.65234 9.68359 2.02734C10.168 2.39453 10.5352 2.86328 10.7852 3.43359C11.0352 4.00391 11.1602 4.6875 11.1602 5.48438C11.1602 6.1875 10.9805 6.82422 10.6211 7.39453C10.2617 7.95703 9.76172 8.41797 9.12109 8.77734C8.48828 9.13672 7.74609 9.36719 6.89453 9.46875L6.08594 10.0195ZM5.98047 18H0.871094L2.14844 16.1602H5.98047C6.69922 16.1602 7.30859 16.0352 7.80859 15.7852C8.31641 15.5352 8.70312 15.1836 8.96875 14.7305C9.23438 14.2695 9.36719 13.7266 9.36719 13.1016C9.36719 12.4688 9.25391 11.9219 9.02734 11.4609C8.80078 11 8.44531 10.6445 7.96094 10.3945C7.47656 10.1445 6.85156 10.0195 6.08594 10.0195H2.86328L2.88672 8.20312H7.29297L7.77344 8.85938C8.59375 8.92969 9.28906 9.16406 9.85938 9.5625C10.4297 9.95312 10.8633 10.4531 11.1602 11.0625C11.4648 11.6719 11.6172 12.3438 11.6172 13.0781C11.6172 14.1406 11.3828 15.0391 10.9141 15.7734C10.4531 16.5 9.80078 17.0547 8.95703 17.4375C8.11328 17.8125 7.12109 18 5.98047 18Z",
      fill: "currentColor"
    })
  });
};

exports.default = Icon;